import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxPopupModule,
  DxSelectBoxModule,
} from 'devextreme-angular';
import { LumpPaymentLinksComponent } from './lump-payment-links.component';

@NgModule({
  imports: [CommonModule, DxPopupModule, DxCheckBoxModule, DxSelectBoxModule, DxButtonModule],
  declarations: [LumpPaymentLinksComponent],
  exports: [LumpPaymentLinksComponent],
})
export class LumpPaymentLinksModule {}
